// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SelectorMenu__container-ebc7ae {
  min-width: 160px;
  box-sizing: border-box;
}

.SelectorMenu__menu-ae5657 {
  overflow: auto;
  max-height: 50vh;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/Selector/SelectorMenu/SelectorMenu.styles.m.css"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,sBAAA;AACF;;AAEA;EACE,cAAA;EACA,gBAAA;AACF","sourcesContent":[".container {\n  min-width: 160px;\n  box-sizing: border-box;\n}\n\n.menu {\n  overflow: auto;\n  max-height: 50vh;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SelectorMenu__container-ebc7ae`,
	"menu": `SelectorMenu__menu-ae5657`
};
module.exports = ___CSS_LOADER_EXPORT___;
